import axios from "axios";
import config from "../Util/config";
import { getToken } from "../Util/Authenticate";
const AddNewUser = async (application) => {
  try {
    await axios.post(
      `${config.BASE_URL}/api/Users/AddNewUser`,
      { ...application },
      {
        headers: {
          // Authorization: `Bearer ${authToken}`
        },
      }
    );

    return true;
  } catch (err) {
    throw err;
  }
};
const AddnewTabFunction = async (application) => {
  try {
    await axios.post(
      `${config.BASE_URL}/api/Admin/AddnewTab`,
      { ...application },
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );

    return true;
  } catch (err) {
    throw err;
  }
};
const AddPlacementTest = async (application) => {
  try {
    await axios.post(
      `${config.BASE_URL}/api/PlacementTest/AddPlacmentTest`,
      { ...application },
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );

    return true;
  } catch (err) {
    throw err;
  }
};

const AddPersonalInformation = async (application) => {
  try {
    await axios.post(
      `${config.BASE_URL}/api/ApplicantInformation/AddNewApplicant`,
      { ...application },
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );

    return true;
  } catch (err) {
    //console.log("ysta el error hna a", err);
    throw err;
  }
};

const AddApplicantToCourse = async (application) => {
  try {
    await axios.post(
      `${config.BASE_URL}/api/ApplicantCourse/AddApplicantToCourse`,
      { ...application },
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return true;
  } catch (err) {
    //console.log("ysta el error hna a", err);
    throw err;
  }
};

const AddCourseData = async (application) => {
  try {
    await axios.post(
      `${config.BASE_URL}/api/Courseinformation/AddNewCourse`,
      { ...application },
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );

    return true;
  } catch (err) {
    throw err;
  }
};
const ForgotYourPassword = async (application) => {
  try {
    await axios.put(
      `${config.BASE_URL}/api/Users/ForgotMyPassword?email=${application}`,
      {},
      {
        headers: {
          // Authorization: `Bearer ${authToken}`
        },
      }
    );

    return true;
  } catch (err) {
    throw err;
  }
};

const UpdateUserData = async (application) => {
  try {
    await axios.put(
      `${config.BASE_URL}/api/Users/UpdateUserData?userId=${application.userId}`,
      { ...application },
      {
        headers: {
          // Authorization: `Bearer ${authToken}`
        },
      }
    );

    return true;
  } catch (err) {
    throw err;
  }
};

const UpdateCurrentUser = async (application) => {
  try {
    await axios.put(
      `${config.BASE_URL}/api/Users/GetUserbyUserID?userId=${application}`,
      { ...application },
      {
        headers: {
          // Authorization: `Bearer ${authToken}`
        },
      }
    );

    return true;
  } catch (err) {
    throw err;
  }
};

const ChangePassword = async (application) => {
  //console.log("Application ysta wenby 3shn t3bt", application);
  try {
    await axios.put(
      `${config.BASE_URL}/api/Users/ChangeMyPassword?userId=${application.userId}`,
      { ...application },
      {
        headers: {
          // Authorization: `Bearer ${authToken}`
        },
      }
    );

    return true;
  } catch (err) {
    throw err;
  }
};

const UpdateCourseData = async (application) => {
  try {
    await axios.put(
      `${config.BASE_URL}/api/Courseinformation/EditCourse?courseId=${application.courseId}`,
      { ...application },
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );

    return true;
  } catch (err) {
    throw err;
  }
};

const UpdatePlacementTestData = async (application) => {
  try {
    await axios.put(
      `${config.BASE_URL}/api/PlacementTest/EditPlacmentTest?testId=${application.placementTestId}`,
      { ...application },
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );

    return true;
  } catch (err) {
    throw err;
  }
};

const ApproveApplicant = async (application) => {
  try {
    await axios.put(
      `${config.BASE_URL}/api/ApplicantCourse/ApproveApplicanttoCourse?applicantCourseID=${application}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );

    return true;
  } catch (err) {
    throw err;
  }
};

const RejectApplicant = async (application) => {
  try {
    await axios.put(
      `${config.BASE_URL}/api/ApplicantCourse/RejectApplicantFromCourse?applicantCourseID=${application}`,
      { ...application },
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );

    return true;
  } catch (err) {
    throw err;
  }
};

const PassApplicant = async (application) => {
  try {
    await axios.put(
      `${config.BASE_URL}/api/ApplicantCourse/PassingApplicantinCourse?applicantCourseID=${application}`,
      { ...application },
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );

    return true;
  } catch (err) {
    throw err;
  }
};

const FailApplicant = async (application) => {
  try {
    await axios.put(
      `${config.BASE_URL}/api/ApplicantCourse/NotPassingApplicantinCourse?applicantCourseID=${application}`,
      { ...application },
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );

    return true;
  } catch (err) {
    throw err;
  }
};

const ApplicantPaid = async (application) => {
  try {
    await axios.put(
      `${config.BASE_URL}/api/ApplicantCourse/GetPaid?applicantCourseID=${application}`,
      { ...application },
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );

    return true;
  } catch (err) {
    throw err;
  }
};

const ApplicantNotPaid = async (application) => {
  try {
    await axios.put(
      `${config.BASE_URL}/api/ApplicantCourse/NotPaid?applicantCourseID=${application}`,
      { ...application },
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          "content-type": "multipart/form-data",
        },
      }
    );

    return true;
  } catch (err) {
    throw err;
  }
};

const ApplicantPlacementTestGrade = async (application) => {
  try {
    await axios.put(
      `${config.BASE_URL}/api/ApplicantPlacementTest/EditResultofPlacementTest?applicantTestID=${application.applicantTestId}`,
      { ...application },
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );

    return true;
  } catch (err) {
    throw err;
  }
};

const RequestRefund = async (application) => {
  try {
    const formData = new FormData();
    for (let [name, value] of Object.entries(application)) {
      formData.append(name, value);
    }
    await axios.put(
      `${config.BASE_URL}/api/ApplicantCourse/ApplicantRequestRefund?applicantCourseId=${application.id}`,
      // { ...application },
      formData,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          // 'Content-Type': 'multipart/form-data'
        },
      }
    );

    return true;
  } catch (err) {
    throw err;
  }
};

const UpdateCourseGrade = async (application) => {
  try {
    await axios.put(
      `${config.BASE_URL}/api/ApplicantCourse/AddCourseGrade?applicantCourseID=${application.ID}`,
      { ...application },
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );

    return true;
  } catch (err) {
    throw err;
  }
};

const DeleteUser = async (application) => {
  try {
    await axios.delete(
      `${config.BASE_URL}/api/Users/DeleteUser?userId=${application}`,
      { ...application },
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );

    return true;
  } catch (err) {
    throw err;
  }
};

const disenrollFromCourse = async (application) => {
  try {
    await axios.delete(
      `${config.BASE_URL}/api/ApplicantCourse/DeleteApplicantCourse?applicantCourseId=${application}`,
      { ...application },
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );

    return true;
  } catch (err) {
    throw err;
  }
};

const UpdateTabData = async (application) => {
  try {
    await axios.post(
      `${config.BASE_URL}/api/Admin/UpdateTab?tabID=${application.tabId}`,
      { ...application },
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );

    return true;
  } catch (err) {
    throw err;
  }
};

const UploadAttachment = async (application) => {
  try {
    // console.log("ysta 2oly el application", JSON.stringify(application));
    // const formData = new FormData();
    // for (let [name, value] of Object.entries(application)) {
    //   formData.append(name, value);
    // }
    // console.log("2oly ya basha1", JSON.stringify(formData));
    // console.log("2oly ya basha2", formData["attachment"]);
    await axios.post(
      `${config.BASE_URL}/api/Admin/AddNewAttachment`,
      // { ...application },
      application,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          // 'Content-Type': 'multipart/form-data'
        },
      }
    );

    return true;
  } catch (err) {
    throw err;
  }
};

const UpdateAttachment = async (application) => {
  try {
    const formData = new FormData();
    for (let [name, value] of Object.entries(application)) {
      formData.append(name, value);
    }
    await axios.post(
      `${config.BASE_URL}/api/Admin/UpdateAttachment?attachmentID=${application.attachmentId}`,
      // { ...application },
      formData,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          // 'Content-Type': 'multipart/form-data'
        },
      }
    );

    return true;
  } catch (err) {
    throw err;
  }
};

const DeleteAttachment = async (id) => {
  try {
    //console.log("Attachment ID", id);
    //console.log("Token", getToken());
    await axios.post(
      `${config.BASE_URL}/api/Admin/DeleteAttachment?attID=${id}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );

    //console.log("Anaa ");
    return true;
  } catch (err) {
    throw err;
  }
};
const DeleteTab = async (id) => {
  try {
    await axios.post(
      `${config.BASE_URL}/api/Admin/DeleteTab?tabID=${id}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return true;
  } catch (err) {
    throw err;
  }
};
export {
  AddNewUser,
  ForgotYourPassword,
  AddPersonalInformation,
  UpdateCurrentUser,
  AddApplicantToCourse,
  disenrollFromCourse,
  UpdateUserData,
  ChangePassword,
  DeleteUser,
  UpdateCourseData,
  AddCourseData,
  UpdatePlacementTestData,
  ApproveApplicant,
  RejectApplicant,
  PassApplicant,
  FailApplicant,
  ApplicantPlacementTestGrade,
  ApplicantPaid,
  ApplicantNotPaid,
  RequestRefund,
  AddPlacementTest,
  UpdateCourseGrade,
  AddnewTabFunction,
  UpdateTabData,
  UploadAttachment,
  UpdateAttachment,
  DeleteAttachment,
  DeleteTab,
};
